import { Box, BoxProps, Select, Typography, styled } from '@mui/material';

import { titleTextColor } from 'assets/styles/_palette';

interface CustomStep extends BoxProps {
	isstepready: boolean;
	isstepactive: boolean;
}

interface StepTitle {
	isstepready: boolean;
}

export const Step = styled(Box)<CustomStep>(({ isstepready, isstepactive }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	padding: '10px 12px 10px 40px',
	borderRadius: '8px',
	width: '100%',
	'&:hover': {
		color: isstepready ? '#4786FF' : '#595959',
	},

	cursor: isstepready ? 'pointer' : 'default',
	color: isstepready ? titleTextColor : '#10214280',
	background: isstepactive ? '#ECF3FF' : 'none',
}));

export const StepTitle = styled(Typography)<StepTitle>(({ isstepready }) => ({
	color: isstepready ? titleTextColor : '#10214280',
	textAlign: 'center',
	fontSize: '14px',
	'@media (max-width: 1536px)': {
		fontSize: '12px',
	},
}));

export const SubStep = styled(Box)<CustomStep>(({ isstepready, isstepactive }) => ({
	padding: '10px 12px 10px 40px',
	width: '100%',
	'&:hover': {
		color: isstepready ? '#4786FF' : '#595959',
	},

	cursor: isstepready ? 'pointer' : 'default',
	color: isstepready ? titleTextColor : '#10214280',
	background: isstepactive ? '#ECF3FF' : 'none',
}));

export const SubStepTitle = styled(Typography)<StepTitle>(({ isstepready }) => ({
	color: isstepready ? titleTextColor : '#10214280',
	fontSize: '12px',
	fontWeight: '400',
}));

export const CustomSelect = styled(Select)({
	'& .MuiOutlinedInput-notchedOutline': {
		border: 'unset',
		padding: '0',
	},
	'& .MuiSelect-select': {
		padding: '0 0 0',
	},
});
